import React from 'react'

export const SlashToSquare = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 437 461"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.0002 175.701L354.997 367.76L354.985 284.263L82.0002 93.056V175.701ZM70.0002 70V181.93L367 390.877L366.984 278.016L70.0002 70Z"
      fill="white"
      id="start"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M355 94H82V367H355V94ZM70 82V379H367V82H70Z"
      fill="white"
      id="end"
      data-shape="square"
    />
  </svg>
)

export const SlashToCircle = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 437 461"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.0002 175.701L354.997 367.76L354.985 284.263L82.0002 93.056V175.701ZM70.0002 70V181.93L367 390.877L366.984 278.016L70.0002 70Z"
      fill="white"
      id="start"
      data-shape="slash"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M218.5 368C293.887 368 355 306.887 355 231.5C355 156.113 293.887 95 218.5 95C143.113 95 82 156.113 82 231.5C82 306.887 143.113 368 218.5 368ZM218.5 380C300.514 380 367 313.514 367 231.5C367 149.486 300.514 83 218.5 83C136.486 83 70 149.486 70 231.5C70 313.514 136.486 380 218.5 380Z"
      fill="white"
      id="end"
      data-shape="circle"
    />
  </svg>
)

export const SlashMirror = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 437 461"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M355 175.701L82.0036 367.76L82.0159 284.263L355 93.056V175.701ZM367 70V181.93L70.0002 390.877L70.0168 278.016L367 70Z"
      fill="white"
      id="start"
      data-shape="slash"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M355 82H82V355H355V82ZM70 70V367H367V70H70Z"
      fill="white"
      id="end"
      data-shape="square"
    />
  </svg>
)

export const Square = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 437 461"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M355 94H82V367H355V94ZM70 82V379H367V82H70Z"
      fill="white"
      id="start"
      data-shape="square"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.0002 175.701L354.997 367.76L354.985 284.263L82.0002 93.056V175.701ZM70.0002 70V181.93L367 390.877L366.984 278.016L70.0002 70Z"
      fill="white"
      id="end"
      data-shape="slash"
    />
  </svg>
)

export const SquareMirror = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 437 461"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M355 94H82V367H355V94ZM70 82V379H367V82H70Z"
      fill="white"
      id="start-mirror"
      data-shape="square"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M355 175.701L82.0036 367.76L82.0159 284.263L355 93.056V175.701ZM367 70V181.93L70.0002 390.877L70.0168 278.016L367 70Z"
      fill="white"
      id="end-mirror"
      data-shape="slash"
    />
  </svg>
)

export const CircleMorphMirror = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 437 461"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M218.5 368C143.113 368 82 306.887 82 231.5C82 156.113 143.113 95 218.5 95C293.887 95 355 156.113 355 231.5C355 306.887 293.887 368 218.5 368ZM218.5 380C136.486 380 70 313.514 70 231.5C70 149.486 136.486 83 218.5 83C300.514 83 367 149.486 367 231.5C367 313.514 300.514 380 218.5 380Z"
      fill="white"
      id="start-mirror"
      data-shape="mirror"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M355 175.701L82.0036 367.76L82.0159 284.263L355 93.056V175.701ZM367 70V181.93L70.0002 390.877L70.0168 278.016L367 70Z"
      fill="white"
      id="end-mirror"
      data-shape="slash"
    />
  </svg>
)

export const CircleMorph = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 437 461"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M218.5 368C293.887 368 355 306.887 355 231.5C355 156.113 293.887 95 218.5 95C143.113 95 82 156.113 82 231.5C82 306.887 143.113 368 218.5 368ZM218.5 380C300.514 380 367 313.514 367 231.5C367 149.486 300.514 83 218.5 83C136.486 83 70 149.486 70 231.5C70 313.514 136.486 380 218.5 380Z"
      fill="white"
      id="start"
      data-shape="circle"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.0002 175.701L354.997 367.76L354.985 284.263L82.0002 93.056V175.701ZM70.0002 70V181.93L367 390.877L366.984 278.016L70.0002 70Z"
      fill="white"
      id="end"
      data-shape="slash"
    />
  </svg>
)

/**
 * The list of shapes a user can cycle through on the homepage.
 * The shapes have their own settings!
 */
export default [
  {
    name: 'Slash',
    Shape: SlashToSquare,
    Mirror: SlashMirror,
    width: 297,
    height: 320.88,
    maxHeight: 342,
    styles: { transform: 'scale(1.47, 1.44)' },
  },
  {
    name: 'Square',
    Shape: Square,
    Mirror: SquareMirror,
    width: 305,
    height: 305,
    maxHeight: 321,
    styles: { transform: 'scale(1.47, 1.55)' },
  },
  {
    name: 'Slash',
    Shape: SlashToCircle,
    Mirror: SlashMirror,
    width: 297,
    height: 320.88,
    maxHeight: 342,
    styles: { transform: 'scale(1.47, 1.44)' },
  },
  {
    name: 'Circle',
    Shape: CircleMorph,
    Mirror: CircleMorphMirror,
    width: 297,
    height: 297,
    maxHeight: 312,
    styles: { transform: 'scale(1.47, 1.54)' },
  },
]
